
export const email = (state) => {
    return state.fyi.fyiDeliveryOptions && state.fyi.fyiDeliveryOptions.M;
}

export const fyiDeviceOptions = (state) => {
    return state.fyi.fyiDeliveryOptions.E;
}

export const fyiDisclaimers = (state) => {
    return state.fyi.fyiDisclaimers;
}

export const fyiNotifications = (state) => {
    return state.fyi.fyiNotifications;
}

export const fyiAlerts = (state) => {
    return state.fyi.fyiAlerts;
}

export const fyiSettings = (state) => {
    return state.fyi.fyiSettings;
}

export const fyiTabState = (state) => {
    return state.fyiTabState;
}

export const countryCodes = (state) => {
    return state.countryCodes;
}

export const feedbackData = (state) => {
    return state.feedbackData;
}

export const fyiUnreadNum = (state) => {
    return state.fyiUnreadNum;
}
